<template>
  <b-modal
    ref="emailnotification-modal-ref"
    hide-footer
    hide-header
    title="Notification"
  >
    <div class="vtd-modal-content">
      <div class="vtd-modal-header">
        <h5 class="vtd-modal-title">Email Notification</h5>
        <button
          @click="closeModal"
          type="button"
          class="close"
          aria-label="Close"
        >
          <span aria-hidden="true"><i class="material-icons">&#xE5CD;</i></span>
        </button>
      </div>
      <div class="vtd-modal-body" v-html="payload.email_body"></div>
      <div class="btn-wrap">
        <div class="vtd-modal-footer vtd-bg-faded vtd-flex-column">
          <small>This information was generated at: <strong>{{ returnDate}}</strong></small>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {returnDate} from '@/lib/utilities'
export default {
  data() {
    return {
      payload: '',
    };
  },
  computed:{
    returnDate() {
      return returnDate()
    }
  },
  methods: {
    showModal(payload) {
      this.$refs["emailnotification-modal-ref"].show();
      this.payload = payload;
    },
    closeModal() {
      this.$refs["emailnotification-modal-ref"].hide();
    },
  }
};
</script>
<style lang="scss">
@import "./style.scss";
</style>

